import { render, staticRenderFns } from "./PaddleCheckout.vue?vue&type=template&id=982e1a8c&"
import script from "./PaddleCheckout.vue?vue&type=script&lang=js&"
export * from "./PaddleCheckout.vue?vue&type=script&lang=js&"
import style0 from "./PaddleCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports